import { AccountsTotalsContext } from 'core/cuenta/contexts/AccountsTotalsContext';
import { useContext } from 'react';
import { formatPeriodo } from 'shared/utils';
import { AccountsTotalsTableWithPagination } from '../AccountsTotalsTableWithPagination/AccountsTotalsTableWithPagination';

export const AccountTotalsList = () => {
  const { accountsTotalsData, searchParams } = useContext(AccountsTotalsContext);

  return (
    <AccountsTotalsTableWithPagination
      cuentas={accountsTotalsData.cuentas}
      totals={accountsTotalsData.totales}
      periodo={formatPeriodo(searchParams)}
    ></AccountsTotalsTableWithPagination>
  );
};
